import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import ImageModal from '../../../components/ImageModal';

const MainRowConf = ({ value, onChange, id='MainRowConf', label = 'Main Row Configuration', disabled = false, showPics = false }) => {
    const [selectedMainRowConf, setSelectedMainRowConf] = useState(value || "1");
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setSelectedMainRowConf(value || "1");
    }, [value]);

    const handleMainRowConfChange = (e) => {
        const newValue = e.target.value;
        // Call onChange first - if it returns false, don't update the internal state
        const result = onChange(newValue);
        // Only update internal state if onChange didn't return false
        if (result !== false) {
            setSelectedMainRowConf(newValue);
        }
    };

    return (
        <div className="a-container">
            <label
                disabled={disabled}
                htmlFor="MainRowConf"
                onClick={() => showPics && setShowModal(true)}
                style={{ cursor: showPics ? 'pointer' : 'default' }}
            >
                {label}
            </label>
            <select
                disabled={disabled}
                id={id}
                value={selectedMainRowConf}
                onChange={handleMainRowConfChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="1">{selectedMainRowConf === "1 section"  ? "1 section ✔"  : "1 section"}</option>
                <option value="2">{selectedMainRowConf === "2 sections" ? "2 sections ✔" : "2 sections"}</option>
                <option value="3">{selectedMainRowConf === "3 sections" ? "3 sections ✔" : "3 sections"}</option>
                <option value="4">{selectedMainRowConf === "4 sections" ? "4 sections ✔" : "4 sections"}</option>
                <option value="5">{selectedMainRowConf === "5 sections" ? "5 sections ✔" : "5 sections"}</option>

            </select>
            <ImageModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                folder="images/MainRowConf"
                imageName={selectedMainRowConf}
                width={200}  //optional
                height={250} //optional
            />
        </div>
    );
};

export default MainRowConf;
